import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

const heroImage =
  "https://readdy.ai/api/search-image?query=Soft%20abstract%20editorial%20background%20with%20flowing%20pastel%20mint%20and%20warm%20cream%20gradient%20shapes%20subtle%20geometric%20patterns%20clean%20minimalist%20aesthetic%20gentle%20diffused%20light%20premium%20modern%20website%20hero%20background%20fresh%20airy%20mood%20high%20detail&width=1600&height=900&seq=hero-usfans-01&orientation=landscape";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="USFans Spreadsheet resource hub background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-32 text-center">
        <p className="animate-fade-up inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-semibold tracking-wide uppercase">
          {t("hero.eyebrow")}
        </p>

        <h1 className="animate-fade-up font-heading font-bold text-foreground-950 text-3xl md:text-5xl leading-tight max-w-4xl mx-auto mt-6">
          {t("hero.title")}
        </h1>

        <p className="animate-fade-up text-foreground-700 text-base md:text-lg max-w-2xl mx-auto mt-6 leading-relaxed">
          {t("hero.description")}
        </p>

        <div className="animate-fade-up flex flex-col sm:flex-row items-center justify-center gap-4 mt-9">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line text-lg"></i>
            {t("hero.explore")}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            {t("hero.buyNow")}
          </a>
        </div>

        <p className="animate-fade-up text-sm text-foreground-600 mt-8 flex items-center justify-center gap-2 flex-wrap">
          <i className="ri-checkbox-circle-line text-primary-500"></i>
          {t("hero.trust")}
        </p>
      </div>
    </section>
  );
}